import { render, staticRenderFns } from "./audiovisualLibrary.vue?vue&type=template&id=2020d652&scoped=true&"
import script from "./audiovisualLibrary.vue?vue&type=script&setup=true&lang=js&"
export * from "./audiovisualLibrary.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./audiovisualLibrary.vue?vue&type=style&index=0&id=2020d652&prod&lang=scss&scoped=true&"
import style1 from "./audiovisualLibrary.vue?vue&type=style&index=1&id=2020d652&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020d652",
  null
  
)

export default component.exports